"use client";

import { useState } from "react";
import { API_URL } from "../../../utils/common";

export interface AdminUsuario {
    id: number;
    nombre: string;
    correo: string;
    idPerfil: number;
    perfil?: string;
    estatus: number | string;
}

export const useGetAdminUser = () => {

    const [usuarios, setUsuarios] = useState<AdminUsuario[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const getToken = () => localStorage.getItem("jwt");

    const obtenerUsuarios = async () => {

        setLoading(true);
        setError(null);

        try {

            const token = getToken();

            if (!token) {
                throw new Error("Token no encontrado");
            }

            const response = await fetch(`${API_URL}/cms/admin/usuarios`, {
                method: "GET",
                headers: {
                    Authorization: `bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error("Error al obtener usuarios");
            }

            const data = await response.json();

            setUsuarios(data);

        } catch (err: any) {

            console.error(err);
            setError(err.message || "Ocurrió un error");

        } finally {

            setLoading(false);

        }
    };

    return {
        usuarios,
        loading,
        error,
        obtenerUsuarios,
    };
};